module.exports = __webpack_public_path__ + "img/police.91f31681.png";